import React, {ReactElement} from 'react';
import {useDispatch} from 'react-redux';
import {jumpToSlideWithIdAction} from '../../../../store/actions/presentation.actions';
import {IElementRectangle} from '../../../../incase-domain/elements/shapes/rectangle';
import {SHAPE_COLOR_DEFAULT} from '../../../../constants';

interface RectangleProps {
    element: IElementRectangle;
    thickness?: number;
}

function Rectangle(props: RectangleProps): ReactElement {
    const {element, thickness = 1} = props;
    const {color, fill, slideChange} = element;
    const resolvedColor = color || SHAPE_COLOR_DEFAULT;

    const dispatch = useDispatch();

    if (fill) {
        return (
            <div className="c-rectangle c-rectangle--filled" onClick={() => dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}>
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                    <rect
                        x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill={resolvedColor}
                        stroke={resolvedColor}
                        strokeWidth={`${thickness}em`}
                    />
                </svg>
            </div>
        );
    }

    return (
        <div className="c-rectangle" onClick={() => dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}>
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                <rect x="0" y="0" width="100%" height="100%" fill="none" stroke={resolvedColor} strokeWidth={`${thickness}em`} />
            </svg>
        </div>
    );
}

export default Rectangle;
